import React from "react";
import { connect } from "react-redux";
import { ReduxState } from "../../../../../store/ReduxState";
import { RouteComponentProps } from "react-router";

import { CreateModel } from "./CreateModel";

interface Params {
    modelId: string;
}

interface StateProps {
    params: Params;
}

type Props = StateProps;

/**
 *
 */
export const mapStateToProps = (s: ReduxState, p: RouteComponentProps): StateProps => ({
    params: p.match.params as Params,
});

/**
 *
 * @param s
 */

/**
 *
 */
export class EditModelComp
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     */
    public constructor(props: Props) {
        super(props);
    }

    public render() {
        return (
            <CreateModel edit modelId={this.props.params.modelId} />
        );
    }
}

/**
 *
 */
export const EditModel = connect(
    mapStateToProps,
    {},
)((props: Props) => <EditModelComp {...props}/>);
